import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { type PledgesDeletRouteModel } from 'donor-elf-web/routes/funds/fund/pledges/delete';
import AbilitiesService from 'donor-elf-web/services/abilities';

export default class PledgeDeleteController extends Controller {
  @service declare abilities: AbilitiesService;
  @service declare flashMessages: any;
  @service declare router: RouterService;

  model!: PledgesDeletRouteModel;

  @tracked error?: any;
  @tracked deleting = false;

  get pledge() {
    return this.model.pledge;
  }

  get pledgeIsPartOfJournalDecision() {
    let { pledge } = this;
    return this.model.journalContactDetails.some((detail) =>
      detail.journalDecisions.slice().some((x) => x.pledgeId === pledge.id),
    );
  }

  get cantDeleteSystemPledge() {
    return !this.pledge.isManual && !this.abilities.hasAbility('edit_pledges');
  }

  @action
  templateWillDestroy() {
    this.deleting = false;
  }

  @action
  async delete() {
    this.error = undefined;
    this.deleting = true;
    try {
      let contactId = this.pledge.contactId;
      await this.pledge.destroyRecord();
      this.flashMessages.success('The pledge was deleted');
      this.router.transitionTo('funds.fund.contacts.contact', contactId);
    } catch (error) {
      this.deleting = false;
      this.error = error;
    }
  }
}
